// Kept separate from predictive-search.js: that file is only loaded on search intent
// (see luxo-loaders.js), so an animator living there never ran until the field was active.
class AnimatePlaceholder {
  /**
   *
   * @param {HTMLInputElement} inputNode search input whose placeholder is animated
   * @param {Array} placeholders set of words to use as placeholders
   */
  constructor(inputNode, placeholders) {
    this.placeholders = placeholders
    this.inputNode = inputNode;
    this.labelNode = document.querySelector(`label.field__label[for="${inputNode.id}"]`);
    this.shouldAnimateDelete = true
    this.isAnimating = false
    this.abortFlag = false
    this.DELAY_AFTER_ANIMATION = 1000
  }

  setPlaceholder(placeholder) {
    this.inputNode.setAttribute("placeholder", placeholder);
    if (this.labelNode) this.labelNode.textContent = placeholder;
  }

  /**
   *
   * @param {Array} currentLetters
   */
  animateDeleteLetters(currentLetters) {
    return new Promise(resolve => {
      if (!currentLetters.length)
        return resolve()

      currentLetters.pop()

      setTimeout(() => {
        this.setPlaceholder(currentLetters.join(""));
        resolve(this.animateDeleteLetters(currentLetters))
      }, this.getRandomDelayBetween(20, 50));
    })
  }

  chooseNewPlaceholder(placeholder = null) {
    let newPlaceholder
    do {
      newPlaceholder = this.placeholders[Math.floor(Math.random() * this.placeholders.length)];
    } while (this.placeholders.length > 1 && placeholder === newPlaceholder);
    this.placeholder = newPlaceholder
  }

  /**
   *
   * @param {string} placeholder
   */
  onAnimationEnd(placeholder) {
    setTimeout(() => {
      this.chooseNewPlaceholder(placeholder)
      this.start();
    }, this.DELAY_AFTER_ANIMATION);
  }

  /**
   *
   * @param {Array} currentLetters
   * @param {Array} remainingLetters
   */
  animateLetters(
    currentLetters,
    remainingLetters,
  ) {
    if (this.abortFlag) return;
    if (!remainingLetters.length) {
      if (this.shouldAnimateDelete)
        setTimeout(async () => {
          await this.animateDeleteLetters([...currentLetters])
          this.onAnimationEnd(currentLetters.join(""))
          this.isAnimating = false

        }, 2000);
      else
        this.isAnimating = false
      return
    }
    this.isAnimating = true;
    currentLetters.push(remainingLetters.shift());
    setTimeout(() => {
      this.setPlaceholder(currentLetters.join(""));
      this.animateLetters(currentLetters, remainingLetters);
    }, this.getRandomDelayBetween(50, 185));
  };

  start() {
    this.abortFlag = false
    this.animateLetters([], this.placeholder.split(""));
  }

  stop() {
    this.setPlaceholder("");
    this.abortFlag = true
  }

  getRandomDelayBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

}

window.AnimateSearchPlaceholder = AnimatePlaceholder

{
  const DELAY_START_ANIMATION = 1000;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inputNode = document.querySelector('.header-search input[type="search"][data-animated-placeholder]');

  // The full prompt is server-rendered, so with reduced motion we simply leave it in place.
  if (inputNode && !prefersReducedMotion) {
    const searchPlaceholder = new AnimatePlaceholder(inputNode, [inputNode.dataset.animatedPlaceholder]);
    searchPlaceholder.shouldAnimateDelete = false;
    searchPlaceholder.chooseNewPlaceholder();
    setTimeout(() => {
      // Don't retype over the prompt while the shopper is already using the field.
      if (searchPlaceholder.isAnimating || inputNode.value || document.activeElement === inputNode) return;
      searchPlaceholder.start();
    }, DELAY_START_ANIMATION);
  }
}
